import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue';
import { useI18n } from '../../locales';
import TuiSelect from './base/Select.vue';
import TuiOption from './base/Option.vue';

import TUIRoomEngine, { TUIVideoQuality } from '@tencentcloud/tuiroom-engine-js';
import { useRoomStore } from '../../stores/room';
import useGetRoomEngine from '../../hooks/useRoomEngine';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoProfile',
  setup(__props) {

const roomEngine = useGetRoomEngine();
const roomStore = useRoomStore();
const { localVideoQuality } = storeToRefs(roomStore);

const { t } = useI18n();

const videoProfileList = computed(() => [
  { label: t('Low Definition'), value: TUIVideoQuality.kVideoQuality_360p },
  { label: t('Standard Definition'), value: TUIVideoQuality.kVideoQuality_540p },
  { label: t('High Definition'), value: TUIVideoQuality.kVideoQuality_720p },
  { label: t('Super Definition'), value: TUIVideoQuality.kVideoQuality_1080p }]);

watch(localVideoQuality, (val: TUIVideoQuality) => {
  roomEngine.instance?.updateVideoQuality({ quality: val });
});

TUIRoomEngine.once('ready', () => {
  roomEngine.instance?.updateVideoQuality({ quality: localVideoQuality.value });
});

return { __sfc: true,roomEngine, roomStore, localVideoQuality, t, videoProfileList, TuiSelect, TuiOption }
}

})